import { computed, makeObservable, observable } from "mobx";

import { ABCStore } from "@noli/business";

type ThemeType = "light" | "dark";
type ThemeStyles = {
  boardBg: string;
  panelBg: string;
  iconColor: string;
  inputColor: string;
  captionColor: string;
  borderColor: string;
  separatorColor: string;
  selectColor: string;
  selectBgColor: string;
  selectHoverColor: string;
  lineButtonColor: string;
  iconButtonColor: string;
  iconButtonHoverColor: string;
  scrollBarColor: string;
  basicButtonColor: string;
  loginBtnColor: string;
  loginBtnTextColor: string;
  loginBtnDisableColor: string;
  containerBg: string; // 模块背景色
  themeColor: string; // 主题色
  filledInputBgColor: string; // 无边框 Input 的背景色
  borderRadius: string;
  fillColor: string;
} & TextStylePropTypes;

type TextColorType =
  | "textColor" // 文本颜色
  | "disabledTextColor" // 文本置灰颜色
  | "titleColor" // 标题颜色
  | "textSecondaryColor"; // 提示色
type TextStylePropTypes = Record<TextColorType, string>;
const darkThemeTextStyles: TextStylePropTypes = {
  textColor: "#ffffff",
  disabledTextColor: "#DCDCDC",
  titleColor: "#E5E5E5",

  textSecondaryColor: "#999999",
};

const lightThemeTextStyles: TextStylePropTypes = {
  textColor: "#4E5969",
  disabledTextColor: "#C9CDD4",
  titleColor: "#000000",
  textSecondaryColor: "#999999",
};

export const allThemes: Record<ThemeType, ThemeStyles> = {
  light: {
    boardBg: "#f7f7f7",
    panelBg: "#ffffff",
    iconColor: "#000000",
    inputColor: "#000000",
    captionColor: "#939393",
    borderColor: "#999999",
    separatorColor: "#eeeeee",
    selectColor: "#333333",
    selectBgColor: "#ffffff",
    selectHoverColor: "#f5f5f5",
    lineButtonColor: "#333333",
    iconButtonColor: "#444444",
    iconButtonHoverColor: "#eeeeee",
    scrollBarColor: "rgba(0,0,0,0.1)",
    basicButtonColor: "#333333",
    loginBtnColor: "#3fc9a8",
    loginBtnTextColor: "#ffffff",
    loginBtnDisableColor: "#afe6d8",
    containerBg: "#ffffff",
    themeColor: "#36C19E",
    filledInputBgColor: "#ffffff",
    /** border */
    borderRadius: "8px",
    fillColor: "#ffffff",
    ...lightThemeTextStyles,
  },
  dark: {
    boardBg: "#242424",
    panelBg: "#323232",
    iconColor: "#b3b3b3",
    inputColor: "#ffffff",
    captionColor: "#cccccc",
    borderColor: "#e5e5e5",
    separatorColor: "#4d4d4d",
    selectColor: "#ffffff",
    selectBgColor: "#545454",
    selectHoverColor: "#656565",
    lineButtonColor: "#cccccc",
    iconButtonColor: "#eeeeee",
    iconButtonHoverColor: "#656565",
    scrollBarColor: "rgba(255,255,255,0.1)",
    basicButtonColor: "#ffffff",
    loginBtnColor: "#3fc9a8",
    loginBtnTextColor: "#ffffff",
    loginBtnDisableColor: "#afe6d8",
    containerBg: "#27272A",
    themeColor: "#36C19E",
    filledInputBgColor: "#585858",
    /** border */
    borderRadius: "8px",
    fillColor: "#5f5f5f",
    ...darkThemeTextStyles,
  },
};

export interface IThemeStore {
  theme: ThemeType;
}
class ThemeStore extends ABCStore<IThemeStore> implements IThemeStore {
  theme: ThemeType = "dark";

  constructor() {
    super();
    makeObservable(this, {
      theme: observable,
      styles: computed,
    });
  }

  get info(): IThemeStore {
    return this;
  }

  get styles(): ThemeStyles {
    return allThemes[this.theme];
  }
}

export const mdScale = 0.75;

/**
 * 生成响应式属性（ px 为单位的都行）
 * @param lg 1920屏幕下的宽度
 * @returns
 */
export const genResponsivePx = (lg: number) => ({ base: `${lg * mdScale}px`, lg: `${lg}px` });

export const themeStore = new ThemeStore();
export const updateTheme = (theme: ThemeType) => themeStore.updateProperty("theme", theme);
